import React, { useEffect, useRef, useState } from 'react';
import { PageHeader } from '../../../constants/style/common.styled';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';
import Button from '../../../components/button';
import {
  useAdvanceBoolean,
  useBoolean,
  useGetGrantAcceptanceTemplateList,
  useGetGrantAcceptanceTemplateVariables,
  usePostGrantAcceptanceTemplate,
  useWealthlaneAwardApi,
} from '../../../hooks';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import GrantAcceptanceTemplateModal from './grantAcceptanceTemplateModal';
import { ModalStatusType } from '../../../types/common';
import InitialValuesForm from '../../../constants/initialValues';
import Spinners from '../../../components/spinner';
import { GrantAcceptanceTemplateHeader } from '../../../constants/table-headers/grantAcceptanceTemplateHeader';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import { useQueryClient } from 'react-query';
import { NoticeService } from '../../../services/wealthlane-award-services';
import {
  useDynamicTable,
  DynamicTable,
  withDynamicTableContext,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import AlertPopup from '../../../components/alert-popup';
import { Form, Formik } from 'formik';
import { Label } from '../../../components/input-text/input.styled';
import ExtendedRichTextEditor, {
  EditorRef,
} from '../../../components/rich-text-editor/extendedRichTextEditor';
import HtmlPreviewer from '../../../components/rich-text-editor/htmlPreviewer';
import _ from 'lodash';
import { axiosInstance } from '../../../services/apiInterceptor';

export const grantAcceptanceTemplateInitialValues = {
  data: InitialValuesForm.grantAcceptanceTemplate,
};

const GrantAcceptanceTemplate = () => {
  const { handleRequest } = useWealthlaneAwardApi();
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [initialData, setInitialData] = useState(grantAcceptanceTemplateInitialValues);
  const editorRef = useRef<EditorRef>(null);

  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
    customValue,
    setCustomValue,
  } = useAdvanceBoolean<string>(false);
  const queryClient = useQueryClient();
  const [modalLoading, setModalLoading] = useState(false);

  const { data: list, status } = useGetGrantAcceptanceTemplateList(handleRequest);

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'GRANT_ACCEPTANCE_TEMPLATE_TABLE_LIST',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });

  const tableActions = [
    {
      action: 'View',
      onClick: (id: string) => {
        setModalStatus('View');
        // getGrantAcceptanceTemplate(id);
        openModal();
      },
    },
    {
      action: 'Edit',
      // as: 'Edit',
      onClick: (id: string) => {
        setModalStatus('Edit');
        // getGrantAcceptanceTemplate(id);
        openModal();
      },
    },
    {
      action: <div className='delete-label'>Delete</div>,
      // as: 'Delete',
      onClick: (id: string) => {
        setModalStatus('Delete');
        setCustomValue(id);
        openConfirmModal();
      },
    },
  ];
  useEffect(() => {
    if (list?.[0]?.id) {
      handleRequest(NoticeService.getApiAwardApiNotices1(list?.[0]?.id))
        .then((data: any) => {
          if (data != null) {
            setInitialData({ data });
          }
        })
        .finally(() => {
          setModalLoading(false);
        });
    }
  }, [list]);

  const onPrimaryClick = (values: Record<string, any>): void => {
    deleteGrantAcceptanceTemplate(customValue);
  };

  const deleteGrantAcceptanceTemplate = (id: string): void => {
    setModalLoading(true);
    handleRequest(NoticeService.deleteApiAwardApiNotices(id))
      .then((data: any) => {
        if (data != null) {
          toast.success(
            <ToastComponent label={'Success'} message={'Grant Acceptance Template deleted.'} />
          );
          void queryClient.invalidateQueries('getGrantAcceptanceTemplateList');
          setModalLoading(false);
          closeConfirmModal();
        }
      })
      .catch(() => {
        setModalLoading(false);
        closeConfirmModal();
      })
      .finally(() => {
        setModalLoading(false);
        void queryClient.invalidateQueries('getGrantAcceptanceTemplateList');
        closeConfirmModal();
      });
  };

  const { data: VariablesList } = useGetGrantAcceptanceTemplateVariables(handleRequest);

  const { mutate, isLoading } = usePostGrantAcceptanceTemplate(handleRequest, closeModal);
  const handleSubmit = (values: any): void => {
    mutate(values);
  };

  const variables = VariablesList?.map((item) => item.replace(/^\[|\]$/g, ''));

  const schema = React.useMemo(
    () => ({
      columns: GrantAcceptanceTemplateHeader({ actions: schemaData?.columns, tableActions }),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );
  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;
  return (
    <>
      <PageHeader className='flex items-end justify-between'>
        <div>
          <Heading variant='h3' title='Grant Acceptance Templates' />
          <Heading
            variant='body-s'
            title={`Grant Acceptance template list.`}
            color={`${COLORS.Gray}`}
          />
        </div>
        {/* <div>
          <Button
            title='Add New Template'
            variant='primary'
            onClick={() => {
              openModal();
              setInitialData(grantAcceptanceTemplateInitialValues);
            }}
            loading={false}
          />
        </div> */}
      </PageHeader>
      {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          modalStatus={modalStatus}
          title={'this Template'}
          handleSubmit={onPrimaryClick}
          // setRemark={setRemark}
          // remark={remark}
          loading={modalLoading}
        />
      )}
      {/* <DynamicTable
        schema={schema}
        data={list ?? []}
        loading={status}
        totalCounts={list?.length ?? 10}
      /> */}
      <div className='bg-white rounded-md p-4 shadow-sm '>
        <Formik
          enableReinitialize
          initialValues={initialData.data}
          // validationSchema={PARTICIPANT_BROADCAST_MESSAGE_VALIDATION}
          onSubmit={(values) => {
            handleSubmit(values);
          }}>
          {({ touched, handleChange, errors, setFieldValue, setFieldTouched, values }) => {
            return (
              <Form>
                <div className='grid sm:grid-cols-12 gap-x-8 mt-6 m-4'>
                  <div className='sm:col-span-6 relative'>
                    <Label className={`label-view`}>Editor</Label>
                    <ExtendedRichTextEditor
                      ref={editorRef}
                      name='content'
                      onChange={(value) => setFieldValue('content', value)}
                      value={values?.content != null ? values?.content : ''}
                      error={errors?.content}
                      touched={touched?.content}
                      variables={variables}
                      variableTypes={true}
                      disabled={modalStatus === 'View'}
                    />
                  </div>

                  <div className='sm:col-span-6'>
                    <Label className={`label-view`}>Preview</Label>
                    <HtmlPreviewer html={values?.content} />
                  </div>
                </div>
                <div className='flex justify-end mt-8 gap-x-5'>
                  <Button
                    title='Cancel'
                    type='button'
                    variant='primary-dark'
                    onClick={() => {
                      setModalStatus('View');
                    }}
                  />
                  <Button
                    title='Save'
                    type='submit'
                    loading={isLoading}
                    variant='primary'
                    icon='check_circle'
                    disabled={_.isEqual(initialData, values)}
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      {/* <AnimationWrapper>
        {isModalOpen && (
          <GrantAcceptanceTemplateModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            initialData={initialData}
            loading={false}
          />
        )}
      </AnimationWrapper> */}
    </>
  );
};

export default withDynamicTableContext(GrantAcceptanceTemplate, false, axiosInstance);
